<template>
  <div>
    <div class="mains" v-if="loading" v-loading="loading" element-loading-spinner="el-icon-loading"></div>
    <div v-else>
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/check' }">点检计划</el-breadcrumb-item>
          <el-breadcrumb-item>新增计划</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="form-box">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
          <!-- 基本信息 -->
          <div class="form-title">基本信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="点检代号" prop="name">
                <el-input v-model="form.name" placeholder="请输入点检代号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="点检日期" prop="date">
                <el-date-picker
                  v-model="form.date"
                  style="width: 335px"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 巡视点信息配置 -->
          <div class="config-title">
            <div class="form-title">
              巡视点信息<span style="color: red"> *</span>
            </div>
            <div>
              <el-button @click="addPatrol" type="primary" size="small">添加巡视点</el-button>
            </div>
          </div>
          <el-table :data="selectPatrolData" style="width: 100%">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column prop="departmentName" label="所属部门"></el-table-column>
            <el-table-column prop="patrolName" label="巡视点名称"></el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <div>
                  <span @click="dltPatrol(scope.row)" style="color:red;cursor:pointer;">删除</span>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- 点检人员配置 -->
          <div class="config-title">
            <div class="form-title">
              点检人员配置<span style="color: red"> *</span>
            </div>
            <div>
              <el-button @click="addConfig" type="primary" size="small">增加配置</el-button>
            </div>
          </div>
          <!-- 配置内容 -->
          <div v-for="(item, key) in form.config" :key="key" class="config-box">
            <div class="title">
              <div style="display: flex;">
                <span class="iconfont icon-peizhi" style="font-size: 20px;margin-right: 5px;"></span>
                <span> 配置 {{key}} </span>
              </div>
              <div><i @click="configDate(key)" v-if="key != 1" class="el-icon-close"></i></div>
            </div>
            <el-form-item label="点检员" prop="">
              <div @click="addStaff(item, key)" class="staffBox">
                <el-tag v-for="staff in item.staffList" :key="staff.id" style="margin-right: 4px;">
                  {{ staff.name }}
                </el-tag>
              </div>
            </el-form-item>
            <el-form-item label="工作时间">
              <i @click="addWorkDate(item)" class="el-icon-plus"></i>
              <div class="setWeek">
                <div v-for="(time, dIndex) in item.workTime" :key="dIndex" class="date">
                  <span class="date-num">{{dIndex+1}}.</span>
                  开始时间：
                  <span style="position: relative;">
                    <lay-time :date="time.startTime" :index="[key, dIndex, 'startTime']" @change="laytimeEnd"></lay-time>
                  </span>
                  结束时间：
                  <span style="position: relative;">
                    <lay-time :date="time.endTime" :index="[key, dIndex, 'endTime']" @change="laytimeEnd"></lay-time>
                  </span>
                  <i @click="deleteDate(item, dIndex)" v-if="dIndex != 0" class="el-icon-close" style="margin-top: 20px;"></i>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="bottom-btn">
            <el-button type="primary" size="small" @click="$router.push('/check')">取消</el-button>
            <el-button type="primary" size="small" @click="onSubmit">提交</el-button>
          </div>
        </el-form>
      </div>
      <!-- 巡视点侧滑 -->
      <el-drawer
        title="添加巡视点"
        :with-header="false"
        :visible.sync="patrolDrawer"
        direction="rtl"
        size="800px">
        <div class="drawer-title">添加巡视点</div>
        <div class="drawer-content table-tree">
          <div class="tree">
            <div class="tree-title">所属部门</div>
            <el-tree
              :data="departmentTreeList"
              node-key="id"
              @node-click="departmentClick"
              :props="patrolProps"
              :default-checked-keys="[1]"
              highlight-current
              :current-node-key="departmentId"
              ref="patrolTree">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span style="margin-right: 40px">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
          <div class="table">
            <el-table :data="tableDataCp" style="width: 500px" height="700" v-loading="patrolLoading" element-loading-spinner="el-icon-loading">
              <el-table-column label="勾选" width="70">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.checked" @change="checkeChange(scope.row)"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="patrolName" label="巡视点名称"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="drawer-bottom">
          <el-button size="small" type="primary" @click="patrolDrawer=false">取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="patrolDrawerOK"
            class="drawer-bottom-ok">确 定</el-button>
        </div>
      </el-drawer>
      <el-drawer
        title=""
        :with-header="false"
        :visible.sync="drawer"
        direction="rtl"
        size="900px">
        <div class="drawer-title">选择点检员</div>
        <div class="drawer-content" v-if="drawer">
          <div class="table-tree">
            <div class="tree">
              <div class="tree-title"><i class="el-icon-share"></i> 结构</div>
              <el-tree
                :data="treeData"
                @node-click="treeRowClick"
                :props="defaultProps"
                :expand-on-click-node="false"
                default-expand-all
                ref="tree">
                <span class="custom-tree-node" slot-scope="{ node }">
                  <span style="margin-right: 40px"><i class="el-icon-folder-opened"></i> {{ node.label }}</span>
                </span>
              </el-tree>
            </div>
            
            <div class="table">
              <el-table :data="tableData" style="width: 100%" height="700">
                <el-table-column width="40">
                  <template slot-scope="scope">
                    <!-- {{staffListID.includes(scope.row.id)}} -->
                    <!-- v-model="scope.row.check" -->
                    <el-checkbox v-model="scope.row.check" :checked="staffListID.includes(scope.row.id)" @change="checked(scope.row)"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="sex" label="性别">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-else>女</span>
                  </template>
                </el-table-column>
                <el-table-column prop="departmentName" label="部门"></el-table-column>
                <el-table-column prop="name" label="岗位">
                  <template slot-scope="scope">
                    <div
                      v-for="item in scope.row.positionInfoList"
                      :key="item.positionId"
                    >{{item.positionName}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="phone" label="电话"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="drawer-bottom">
          <el-button type="primary" size="small" @click="drawer=false">取消</el-button>
          <el-button size="small" type="primary" @click="drawerOK" class="drawer-bottom-ok">确 定</el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import layTime from '@/components/layTime'
export default {
  components: {
    layTime
  },
  data() {
    return {
      loading: false,
      patrolLoading:false,
      form: {
        patrolIds: [],
        config: {}
      },
      rules: {
        name:[{ required: true, message: '必填项', trigger: 'blur' }],
        date:[{ required: true, message: '必填项', trigger: 'change' }]
      },
      props: {
        value: 'id',
        label: 'name',
        children: 'childTree'
      },
      patrolDrawer: false,
      departmentId: 0,
      departmentTreeList: [],
      tableDataCp:[],
      tableSelectList: [],
      selectPatrolData: [],
      patrolProps: {
        children: 'childTree',
        label: 'name'
      },

      options: [],
      bumen: [],
      value: [],
      value1: [],
      patrolList: [],
      staffList: [],
      index: 1,
      departmentTree: [],
      drawer: false,
      treeData: [],
      tableData: [],
      defaultProps: {
        children: 'childTree',
        label: 'name'
      },
      checkedStaffList: [],
      staffListID: [],
      configKey: '',
      pickerOptions: {
        disabledDate: time => {
          let d = dayjs(time).format("YYYYMMDD").valueOf();
          let n = dayjs().format("YYYYMMDD").valueOf();
          return d < n;
        }
      },
    }
  },
  methods: {
    // 添加巡视点
    addPatrol(){
      this.patrolDrawer = true
      this.tableDataCp.forEach((v)=>{ 
        if (this.selectPatrolData.find(item => item.id == v.id)) {
          v.checked = true
        }else {
          v.checked = false
        }
      })
    },
    // 点击部门获取对应巡视点
    departmentClick(data,node){
      if(this.tableSelectList.length==0){
        this.tableDataCp = []
        this.tableSelectList = []
        this.selectPatrolData = []
        this.getPatrolList(data.id, data.name)
      }else {
        if(this.tableSelectList[0].departmentId==data.id) {
          this.$refs.patrolTree.setCurrentKey(data.id)
        }else{
          node.isCurrent = false
          this.$refs.patrolTree.setCurrentKey(this.tableSelectList[0].departmentId)
          this.$message.error("不能跨部门选择巡视点信息！");
        }
      }
    },
    getPatrolList(id, name){
      this.patrolLoading = true
      this.$ajax.post("patrolList", {
        departmentId: id
      }).then((res) => {
        res.data.forEach(v => {
          v.checked = false
          v.departmentId = id
          v.departmentName = name
          this.tableDataCp.push(v)
        })
        this.patrolLoading = false
      }).catch(err=>{
        this.patrolLoading = false
      })
    },
    // 勾选设备
    checkeChange(row) {
      if (row.checked) {
        // 勾选
        this.tableSelectList.push(row)
      } else {
        this.tableSelectList.forEach((item, index) => {
          if (item.id == row.id) {
            this.tableSelectList.splice(index, 1)
          }
        })
      }
    },
    // 选择巡视点点击确定
    patrolDrawerOK(){
      this.patrolDrawer = false
      this.selectPatrolData = []
      this.tableSelectList.forEach(v=>{
        this.selectPatrolData.push(v)
      })
    },
    // 删除巡视点信息
    dltPatrol(row){
      this.selectPatrolData.forEach((item, index) => {
        if (item.id == row.id) {
          this.selectPatrolData.splice(index, 1)
        }
      })
      this.tableSelectList.forEach((v,k) => {
        if (v.id == row.id) {
          this.tableSelectList.splice(k, 1)
        }
      })
    },
    configDate(index) {
      this.$delete(this.form.config, index)
    },
    laytimeEnd(index, date) {
      this.form.config[index[0]].workTime[index[1]][index[2]] = date
    },
    drawerOK() {
      this.drawer = false
      this.form.config[this.configKey].staffList = [].concat(this.checkedStaffList)
      this.form.config[this.configKey].staffListID = [].concat(this.staffListID)
    },
    checked(row) {
      // if (row.check) {
      if (!this.staffListID.includes(row.id)) {
        this.checkedStaffList.push(row)
        this.staffListID.push(row.id)
      } else {
        this.checkedStaffList.forEach((item, index) => {
          if (item.id == row.id) {
            this.checkedStaffList.splice(index, 1)
            this.$delete(this.staffListID, index)
            console.log(this.staffListID)
          }
        })
      }
    },
    loadTableData(id) {
      this.$ajax.post('queryFilter', {
        departmentId: id ? id : 0
      }).then(res => {
        res.data.forEach(item => {
          let inIs = this.staffListID.find(function(obj) {
            return obj == item.id
          })
          if (!inIs) {
            item.check = false
          }else {
            item.check = true
          }
        })
        this.tableData = res.data
      })
    },
    treeRowClick(data) {
      this.loadTableData(data.id)
    },
    loadTreeData() {
      this.$ajax.post('departmentResponsibleChild').then(res => {
        this.treeData = res.data
      })
    },
    addStaff(item, key) {
      this.loadTableData(this.treeData[0].id)
      this.configKey = key
      this.staffListID = []
      item.staffList.forEach(item => {
        this.staffListID.push(item.id)
      })
      this.checkedStaffList = [].concat(item.staffList)
      
      this.drawer = true
    },
    deleteDate(item, dIndex) {
      this.$delete(item.workTime, dIndex)
    },
    addWorkDate(item) {
      item.workTime.push({
        startTime: '00:00:00',
        endTime: '23:00:00'
      })
    },
    addConfig() {
      this.$set(this.form.config, this.index, {
        staffList: [],
        workTime: [{
          startTime: '00:00:00',
          endTime: '23:00:00'
        }]
      });
      this.index++;
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let unsub = true
          let _this = this
          let form = {
            taskType: 1,
            taskCode: this.form.name,
            startDate: this.form.date,
            endDate: 0,
            patrolIds: [],
            departmentId: 0,
            staffGroups: []
          }

          this.selectPatrolData.forEach((v)=>{
            form.patrolIds.push(v.id)
            form.departmentId = v.departmentId
          })

          for (let item in this.form.config) {
            if(this.form.config[item].staffListID==undefined){
              this.$message.error("人员配置不能为空！");
              return
            }
            form.staffGroups.push({
              staffIds: this.form.config[item].staffListID,
              frequencyDates: getfrequencyDate(this.form.config[item].workTime)
            })
          }

          if (form.patrolIds.length == 0) {
            this.$message.error("巡视点信息不能为空！");
            return
          }

          if (form.staffGroups.length == 0) {
            this.$message.error("人员配置不能为空！");
            return
          }

          for(let i in this.form.config){
            if(this.form.config[i].workTime.length == 0) {
              this.$message.error("工作时间不能为空！");
              return
            }
          }

          function getfrequencyDate (arr) {
            var data = []
            let arrs = []
            arr.forEach(a => {
              arrs.push({
                startTime: _this.dateSecond(a.startTime),
                endTime: _this.dateSecond(a.endTime)
              })
              if (_this.dateSecond(a.startTime) > _this.dateSecond(a.endTime)) {
                unsub = false
              }
            })
            data.push({
              frequencyTimeInfos: arrs
            })
            return data
          }
          
          if (unsub) {
            this.loading = true
            this.$ajax.post("rulePatrolCreate", form).then((res) => {
              this.loading = false
              this.$message.success("成功");
              this.$router.push("/check");
            }).catch(err=>{
              this.loading = false
            })
          } else {
            this.$message.error("开始时间 不能大于 结束时间！");
          }
        }
      })
    },
    dateSecond(str) {
      let strArr = str.split(':')
      let second =  (strArr[0] * 3600) + (strArr[1] * 60) + Number(strArr[2])
      return second
    },
    loadPatrolList() {
      this.$ajax.post("patrolList", {
        facilityId: ''
      }).then((res) => {
        this.patrolList = res.data;
      });
    },
    load_bumen() {
      this.$ajax.get("departmentTree").then((res) => {
        this.bumen = this.getTreeData(res.data);
      });
    },
    getTreeData(data) {
      let arr = [];
      if (Array.isArray(data)) {
        let sss = (d) => {
          d.forEach((item, index) => {
            arr.push({
              id: item.id,
              name: item.name,
            });
            if (item.childTree.length > 0) {
              sss(item.childTree);
            }
          });
        };
        sss(data);
      }
      return arr;
    },
    loadStaffList() {
      this.$ajax.get("staffDueryAll").then((res) => {
        this.staffList = res.data;
      });
    },
    loadDepartmentTree() {
      this.$ajax.get("departmentTree").then((res) => {
        this.departmentTree = res.data;
      });
    },
    departmentList(){
      this.$ajax.get("departmentResponsibleSecondLevel").then((res) => {
        this.departmentTreeList = res.data;
        this.departmentClick(res.data[0])
        this.departmentId = res.data[0].id
      })
    }
  },
  mounted() {
    this.departmentList()
    this.loadPatrolList()
    this.loadStaffList()
    this.loadTreeData()
    // this.load_bumen()
    // this.loadDepartmentTree()
  }
}
</script>

<style lang="less" scoped>
.mains {
  padding: 400px 0;
  height: 100%;
}
/deep/.el-loading-spinner .el-icon-loading{
  font-size: 50px;
}
.el-icon-plus {
  font-weight: bold;
  color: #1494fb;
  margin-left: 20px;
  cursor: pointer;
}
.breadcrumb {
  padding: 15px 10px;
  .el-breadcrumb {
    font-size: 18px;
  }
}
.config-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
}
.table-tree {
  display: flex;
  height: ~'calc(100% - 110px)';
  margin-top: 20px;
  .tree {
    width: 220px;
    border-right: 4px solid #f6f7fb;
    margin-right: 20px;
  }
  .table {
    flex: 1;
  }
  .operate {
    &:hover {
      color: #409EFF;
    }
  }
  .custom-tree-node {
    font-size: 14px;
  }
}
.staffBox {
  cursor: pointer;
  border: 1px solid #ebeef5;
  border-radius: 5px;
  margin-right: 140px;
  padding: 4px;
  min-height: 40px;
  transition: all .3s ease;
}
.staffBox:hover {
  box-shadow: 0px 0px 10px rgba(211, 211, 211, 0.5);
}
.el-icon-close {
  color: #1494fb;
  margin-right: 10px;
  cursor: pointer;
  float: right;
  font-size: 20px;
}
.config-box {
  box-shadow: 0px 0px 10px rgba(211, 211, 211, 0.5);
  border: 1px solid #ebeef5;
  border-radius: 10px;
  margin: 20px 0;
  .title {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ebeef5;
  }
}
.setWeek {
  border-top: 0;
  .date {
    padding-bottom: 20px;
    padding-right: 10px;
    font-size: 14px;
  }
  .date-num {
    font-size: 12px;
    margin: 0 10px;
  }
  .title {
    font-size: 14px;
    padding-left: 10px;
    line-height: 30px;
    background-color: #f6f7fb;
  }
  .box {
    padding: 10px;
    margin-bottom: 6px;
  }
  .box:last-child {
    margin: 0;
  }
}
.checkbox {
  margin-bottom: 20px;
  padding-left: 40px;
}
/deep/.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff;
  color: white;
}
.drawer-bottom {
  position: static;
  z-index: 1;
  text-align: right;
  padding: 10px 20px 10px 0;
}
</style>
<style lang="less">
.el-drawer.rtl {
  overflow: scroll;
}
</style>